// TASK-20260824-twap-parents-org-scope-400 — the TWAP parents read owned by Orders.svelte.
//
// Extracted from the component so it is directly testable: this project has no component-mount
// harness (vitest + svelte, no testing-library), so a loader written inline in a .svelte file is
// only ever covered transitively by scopedLoader.test.js — which is how the no-resolved-org skip
// went missing here in the first place.
//
// Every tenant-scoped read goes through createScopedLoader (TASK-20260818 F1/F8). It enforces both
// halves of the guard, and the half this component was missing is the first one:
//   1. No resolved org  -> skip entirely. A scope-less read is a guaranteed 400 (ADR-0023), and the
//      startup window (when $orders lands before $selectedOrgId resolves) is normal, not a failure.
//   2. Capture-then-compare: a response — success OR failure — that arrives after the org moved on
//      is dropped, so a superseded tenant's data can never sit on screen.
import { createScopedLoader } from '../../lib/scopedLoader.ts';

/** The blotter reads one page big enough to cover the venue's order list (server max is 200). */
export const TWAP_PARENTS_PAGE_SIZE = 200;

/**
 * Builds the parents loader. `api` is injected so the test can drive it; the component passes the
 * real client.
 *
 * @param {object}   deps
 * @param {() => (string|null|undefined)} deps.getOrgId  reads the CURRENT selected org
 * @param {{ getTwapParents: (filters: object, orgId: string) => Promise<{items?: unknown[]}> }} deps.api
 * @param {(items: unknown[]) => void} deps.apply        commits a still-current page
 * @param {(err: unknown) => void}     deps.onError      handles a still-current failure
 * @returns {() => Promise<void>}
 */
export function createTwapParentsLoader({ getOrgId, api, apply, onError }) {
  return createScopedLoader({
    getOrgId,
    load: async (orgId) => {
      const page = await api.getTwapParents({ pageSize: TWAP_PARENTS_PAGE_SIZE }, orgId);
      return Array.isArray(page?.items) ? page.items : [];
    },
    apply,
    onError,
  });
}
